const actions = {
  SET_STATE: 'pages/company/reports/SET_STATE',
};

export default actions;
